import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DictHandler } from 'src/app/types/@types/sl-v-types';
import { SLMap } from 'src/app/model/sl-map';
import { SLLayer } from 'src/app/model/sl-layer';



@Injectable({
	providedIn: 'root'
})
export class LayerSelectionDialogService {
	public request$: Subject<any> = new Subject();
	constructor() { }

	ListSLMapLayers(slMap: SLMap, selectDefault = true, selections: any, handler: DictHandler): void {
		this.request$.next({ handler: (handler), map: slMap, mode: 'from-map', selectDefault: (selectDefault) });
	}
	ListLayerViews(selectDefault = true, selections: any, handler: DictHandler): void {
		this.request$.next({ handler: (handler), map: SLMap, selections: (selections), mode: 'from-views', selectDefault: (selectDefault) });
	}
	ListSLLayerSet(layerSet: Array<SLLayer>, selectDefault = true, selections: any, handler: DictHandler) {
		if (!(!!selections)) {
			selections = {};
		}
		this.request$.next({ handler: (handler), layers: layerSet, mode: 'from-set', selections: (selections), selectDefault: (selectDefault) });
	}
	ShowGallery(currentMomentId: string = '', handler: DictHandler = null) {
		this.OpenGallery(handler);
	}
	OpenGallery(handler: DictHandler = null) {
		if (handler === null) {
			handler = (arg: any) => { };
		}
		this.request$.next({ mode: 'gallery', handler: (handler) });
	}
}
